import React from "react";
import { NavLink } from "react-router-dom";

const LinkBtn = React.forwardRef(function LinkBtn(props, ref) {
  // eslint-disable-line
  return <NavLink  ref={ref} to={props.to} {...props} />;
});
export default LinkBtn;
